import { CoreActionKeys as keys } from './coreActionKeys';
import { CoreActionTypes } from './coreActionTypes';

export interface ICoreState {
  appInitialized: boolean;
}

const initialState: ICoreState = {
  appInitialized: false
};

export function coreReducer(state: ICoreState = initialState, action: CoreActionTypes): ICoreState {
  switch (action.type) {
    case keys.APP_INITIALIZED:
      return {
        ...state,
        appInitialized: true
      };
    default:
      return state;
  }
}
